module.exports = __webpack_public_path__ + "static/bg (5)-b2dc72a795b1a67a3ea5cc8c7036f8e0.jpg";